<template>
  <div>
    <van-dialog v-model="show" width="256" :show-cancel-button="false" :show-confirm-button="false">
      <div class="wrapper">
        <img class="close" @click="show = false" src="../../../../../../static/img/tcX.png" />
        <img class="img" v-if="type == 0" src="../../../../../../static/img/qd_type0.png" />
        <img class="img" v-if="type == 1" src="../../../../../../static/img/qd_type1.png" />
        <img class="img" v-if="type == 2" src="../../../../../../static/img/qd_type2.png" />
        <div class="time" v-if="this.time && type !== 2" :style="{ color: dialogTypeList[type].color }">
          {{ this.time }}
        </div>
        <div v-if="type == 0" class="text">打卡成功</div>
        <div v-if="type == 1" class="text">打卡成功</div>
        <div v-if="type == 2" class="textX">打卡失败！</div>
        <div class="btnWrapper">
          <div class="btn" @click="close" :style="{ color: dialogTypeList[type].color }">
            {{ dialogTypeList[type].confirmButtonText }}
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
      time: '',
      dialogTypeList: [
        {
          confirmButtonText: '我知道了',
          color: '#0189F9',
          imgUrl: '../../../../../../static/img/qd_type0.png',
        },
        {
          confirmButtonText: '我知道了',
          color: '#FFA400',
          imgUrl: '../../../../../../static/img/qd_type1.png',
        },
        {
          confirmButtonText: '重新打卡',
          color: '#F85352',
          imgUrl: '../../../../../../static/img/qd_type2.png',
        },
      ],
    }
  },

  created() {},
  methods: {
    close() {
      if (this.type == 2) {
        this.show = false
        console.log('重新打卡')
      } else {
        this.show = false
        console.log('成功失败')
      }
    },
    open() {
      var myDate = new Date()
      this.time = (myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours()) + ':' + (myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes())
      this.show = true
    },
  },
  // computed: {
  //   getConfirmButtonColor(){
  //     if(this.type == '1'){
  //       return '#0189F9'
  //     }
  //   },
  //   getConfirmButtonText(){
  //     if(this.type == '1'){
  //       return '我知道了'
  //     }
  //   }
  // }
}
</script>

<style lang="less" scoped>
.van-dialog__confirm {
  background: #fff !important;
}
.wrapper {
  width: 256px;
  position: relative;
  .close {
    z-index: 99999;
    width: 15px;
    height: 14px;
    position: absolute;
    top: 14px;
    right: 16px;
  }
  .img {
    width: 111px;
    height: 82px;
    margin: 68px 72px 0 73px;
  }
  .time {
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 44px;
    color: #0189f9;
    letter-spacing: 0;
    text-align: center;
    line-height: 62px;
    margin-top: 6px;
  }
  .text {
    line-height: 84px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    text-align: center;
  }
  .textX {
    line-height: 132px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 20px;
    color: #f85352;
    letter-spacing: 0;
    margin-left: 85px;
  }
  .btnWrapper {
    width: 256px;
    height: 45px;
    border-top: 1px solid #e5e5e5;
    line-height: 45px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/components/statePop.vue